import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class TokenExpirationInterceptor implements HttpInterceptor {
  private localStorageService = inject(LocalStorageService);
  private authService = inject(AuthService);
  private router = inject(Router);


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Check if the request URL should be excluded from interception
    if (this.shouldExcludeRequest(request.url)) {
      return next.handle(request); // Skip interception for this request
    }

    if (this.isTokenExpired()) {
      this.authService
        .logout()
        .then(() => {
          this.router.navigate(['/']);
        })
        .catch(() => {
          this.router.navigate(['/']);
        });
    }

    // Token is still valid, continue with the request
    return next.handle(request);
  }

  /**
   * This see if the actual request is not one of the excludedUrls
   * to keep with its life normally
   * @param url
   * @returns
   */
  private shouldExcludeRequest(url: string): boolean {
    const excludedUrls = [
      '/LoginWithEmailAddress',
      '/RegisterPlayFabUser',
      '/UpdateUserData',
      '/SendAccountRecoveryEmail',
    ];
    return excludedUrls.some((excludedUrl) => url.endsWith(excludedUrl));
  }

  /**
   * This checks if the TokenExpirationDate with the actual date is
   * mayor or equal to return a false or true.
   * if there is no token to compare with the actual date, nothing has expired and return false
   * @returns boolean
   */
  private isTokenExpired(): boolean {
    // console.log(
    //   "this.localStorageService.get('TokenExpirationDate') > ",
    //   this.localStorageService.get('TokenExpirationDate'),
    // );
    if (this.localStorageService.get('TokenExpirationDate')) {
      const tokenExpirationDate = new Date(
        this.localStorageService.get('TokenExpirationDate'),
      );
      const currentDate = new Date();

      return currentDate >= tokenExpirationDate;
    }
    return false;
  }
}
